import { Button, Form, Grid, Input, message, Select } from 'antd';
import { ContentFilters } from 'components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UploadFilterFormField, UploadFilterFormValues } from './types';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { useUserContext } from 'features/users';

const { useBreakpoint } = Grid;

type UsersFilterFormProps = {
    formId: string;
    handleFilter: (values: UploadFilterFormValues) => void;
    initialValues: UploadFilterFormValues;
    closeModal?: () => void;
};

export const UploadFilterForm = ({
    formId,
    handleFilter,
    initialValues,
    closeModal,
}: UsersFilterFormProps) => {
    const { user } = useUserContext();
    const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
    const [form] = Form.useForm<UploadFilterFormValues>();
    const { t } = useTranslation();
    const screens = useBreakpoint();
    const onReset = () => {
        form.resetFields();
        handleFilter({ ...initialValues });
    };

    const [event, setEvent] = useState('' as any)

    const onFinish = (formValues: UploadFilterFormValues) => {
        const formattedValues = {
            ...formValues,
        };
        handleFilter(formattedValues);
        closeModal?.();
    };

    const getEvent = async () => {
        try {
            // `Flag=${'Events'}`
            const apires = await TransectionApiServices().getCommonDropDown({
                flag: "Events",
                AgentId: user?.user_id,

            } as any)
            setEvent(apires as any)
        } catch (error) {
            message.error('')
        }
    }
    useEffect(() => {
        getEvent();
    }, [])


  

    return (

        <Form<UploadFilterFormValues>
            id={formId}
            name={formId}
            className='filters-form grp_form'
            form={form}
            layout='vertical'
            onFinish={onFinish}
            initialValues={initialValues}
            onFinishFailed={() => {
                setValidateTrigger(['onChange']);

            }}
            validateTrigger={validateTrigger}
        >
            <ContentFilters.FormItemsWrapper>

                <div className='invoice_list grp_listf'>
                    <Form.Item
                        label={'Event Name'}
                        name={"EventId"}
                    >
                        {/*  */}
                        <Select
                            showSearch
                            options={event?.dropDownList?.map((res: any) => ({ label: res.Name, value: res.Id }))}
                            placeholder={"Select Event Name"}
                            //onChange={(value: string) => getTickets(value)}
                            filterOption={(input: any, option: any) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>

                    <Form.Item
                        label={'Group Name'}
                        name={UploadFilterFormField.GroupName}
                    >
                        <Input placeholder={'Enter Group Name'} />
                    </Form.Item>

                    <Form.Item
                        label={'EMAIL'}
                        name={UploadFilterFormField.Email}
                    >
                        <Input placeholder={'Enter Email'} />
                    </Form.Item>
                    <Form.Item
                        label={'Mobile'}
                        name={UploadFilterFormField.Phone}
                    >
                        <Input placeholder={'Enter Mobile No'} />
                    </Form.Item>
                    <Form.Item
                        label="Origin"
                        name="Origin"
                    >
                        <Select
                            defaultValue={'All'}
                            placeholder="Select Origin"
                            options={[
                                { value: 'NULL', label: 'All' },
                                { value: 'GroupRegistration', label: 'GroupRegistration' },
                                { value: 'BulkUpload', label: 'BulkUpload' },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Registartion status"
                        name="RegistrationStatus"
                    >
                        <Select
                            defaultValue="All"
                            style={{ width: "100%" }}
                            options={[
                                { value: 'ALL', label: 'All' },
                                { value: 'Close', label: 'Close' },
                                { value: 'Open', label: 'Open' },
                            ]}
                        />
                    </Form.Item>
                    {screens.lg && (
                        <ContentFilters.ButtonsWrapper className='filter_btn'>
                            <Button type='primary' htmlType='submit'>
                                {t('common.buttons.filter', { count: 1 })}
                            </Button>
                            <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
                        </ContentFilters.ButtonsWrapper>
                    )}

                </div>

            </ContentFilters.FormItemsWrapper>

        </Form>
    );
};
